<!-- Menubar -->
<div class="row spacer-top" ng-show="vm.docready">
  <!-- viewer column  -->
  <div class="col-xs-12 col-md-6">
    <!-- PDF viewer actions-->
    <div class="pull-left">
      <div ng-show="vm.pdferror !== true">
        <button class="btn btn-info" ng-click="vm.zoomIn()" uib-tooltip="Hineinzoomen"><i
          class="fa fa-search-plus"></i></button>
        <button class="btn btn-info" ng-click="vm.zoomOut()" uib-tooltip="Herauszoomen"><i
          class="fa fa-search-minus"></i></button>
        <button class="btn btn-info" ng-click="vm.rotatePage()" uib-tooltip="Dokument drehen"><i
          class="fa fa-rotate-right"></i></button>
        <button class="btn btn-info" ng-click="vm.previousPage()" uib-tooltip="Zurückblättern"><i
          class="fa fa-arrow-left"></i></button>
        <!--  Seite: {{vm.currentpage}} / {{vm.maxpc}}  -->
        <form style="display: inline" class="form-horizontal">
          <label for="pagenr"> Seite: </label>
          <input type="number" class="form-control"
                 style="display: inline; width: 4em"
                 width="5em" name="pagenr" id="pagenr"
                 ng-change="vm.gotoPage()"
                 ng-model="vm.currentpage">
          <label>/{{vm.maxpc}}</label>
        </form>
        <button class="btn btn-info" ng-click="vm.nextPage()" uib-tooltip="Vorblättern"><i
          class="fa fa-arrow-right"></i></button>

      </div>


    </div>

    <!-- ************************************************************ -->
    <!-- Document Viewer                                              -->
    <!-- ************************************************************ -->
    <div>
      <div class="alert alert-info spacer-top spacer-bottom" ng-show="vm.docloading">
        <h3><i class="fa fa-spinner fa-spin"></i> Dokument wird geladen ...</h3>
      </div>


      <!--  Broken Document / wrong doc type warning    -->
      <div class="alert alert-warning" ng-show="vm.pdferror === true">
        <h4 class="spacer-top spacer-bottom">
          Das Dokument ist wahrscheinlich defekt, oder gar kein PDF Dokument. Sie können das Dokument
          herunter laden und lokal betrachten.</h4>
        <a href="/routes/files/filedownload/{{vm.file.fileid}}">
          <div class="spacer-top spacer-bottom btn btn-primary">
            <i class="fa fa-download"></i> Dokument herunterladen
          </div>
        </a>
        <h4 class="spacer-top">Informationen für Fehlerreport</h4>

        <div class="spacer-top">Mimetype: {{vm.file.mimetype}} {{vm.file.mimeType}}</div>
        <div>fileid: {{vm.file.fileid}}</div>
        <div>Share: {{vm.file.sharetype}}</div>
        <div>Endpoint: {{vm.file.endpoint}}</div>
        <div>Type: {{vm.file.type}}</div>
        <div>Filecat: {{vm.file.filecat}}</div>
        <div>Filename: {{vm.file.filename}}</div>
      </div>

      <!-- PDF Viewer -->
      <div style="position: relative">
        <pdf-viewer ng-hide="vm.pdferror === true"
                    delegate-handle="scans-pdf-container"
                    url="pdfUrl"
                    scale="1.2"
                    show-toolbar="false"
                    ng-class="vm.landscape ? 'landscapeview' : 'portraitview'"
        >
        </pdf-viewer>
      </div>
    </div>


  </div>
  <!-- ************************************************************ -->
  <!-- Assignment column                                            -->
  <!-- ************************************************************ -->
  <div class="pull-right col-xs-12 col-md-6">
    <!-- document assigment menu -->
    <div>
      <!-- scan sorter menu -->
      <span ng-show="vm.filemode === 'scan'">
                <button data-hook="assign_patient" class="btn btn-success" ng-click="vm.assignCat('patient')"
                        uib-tooltip="Dokument Patient zuordnen">
                    <i class="fa fa-arrow-down"></i><i class="fa fa-user"></i>
                </button>
                <button data-hook="assign_generic" class="btn btn-success" ng-click="vm.assignCat('generic')"
                        uib-tooltip="Allgemeines Dokument zuordnen">
                    <i class="fa fa-arrow-down"></i><i class="fa fa-book"></i>
                </button>
                <button class="btn btn-warning" data-hook="finish_assignment"
                        data-ng-disabled="vm.formDisabled(vm.file) || vm.saving === true"
                        ng-click="vm.finish()"
                        uib-tooltip="Dokument abschliessen">
                    <i class="fa fa-check" data-hook="assign_saved" ng-if="vm.saved === true"></i>
                    <i class="fa fa-spin fa-spinner" ng-if="vm.saving === true"></i>
                    <i class="fa fa-warning" uib-tooltip="Bitte noch einmal probieren" ng-if="vm.saverror === true"></i>
                  Dokument abschließen
                </button>
            </span>
      <!-- scan signoff menu -->
      <span ng-show="vm.filemode === 'signoff'">
        <span class="input-group">
            <input type="text" data-hook="signature" class="form-control" ng-model="vm.file.signature"
                   placeholder="Signatur">
            <span class="input-group-btn">
                <button class="btn btn-warning" data-hook="finish_signoff"
                        data-ng-disabled="vm.formSignoffDisabled(vm.file)"
                        ng-click="vm.finishSignoff()"
                        uib-tooltip="Dokument abschließen">
                    <i class="fa fa-check"  data-hook="signoff_saved"  ng-if="vm.saved === true"></i>
                    <i class="fa fa-spin fa-spinner" ng-if="vm.saving === true"></i>
                    <i class="fa fa-warning" uib-tooltip="Bitte noch einmal probieren" ng-if="vm.saverror === true"></i>
                    Dokument vidieren
                </button>
            </span>
        </span>

    </span>
    </div>


    <div>
      <form class="form-vertical spacer-top">
        <!-- keywords -->
        <div class="row" ng-show="vm.file.doccat">
          <div class="col-xs-12">
            <div class="form-group">
              <label for="dockeywords">Stichworte</label>
              <tags-input ng-model="vm.file.keywords" data-hook="keywords"
                          display-property="text"
                          id="filekeywords{{$index}}"
                          add-on-paste="true"
                          add-on-comma="false"
                          add-on-enter="true"
                          min-length="1"
                          ng-blur="vm.saveKeywords()"
                          enable-editing-last-tag="true"
                          add-from-autocomplete-only="false"
                          replace-spaces-with-dashes="false"
                          template="filetag-template">
                <auto-complete source="vm.getTags($query)"
                               min-length="1"
                               load-on-focus="true"
                               load-on-empty="false"
                               load-on-down-arrow="true"
                               max-results-to-show="32"
                               select-first-match="true"
                               template="filetagautocomplete-template">
                </auto-complete>
              </tags-input>
            </div>
          </div>
        </div>

        <!--on-tag-added="vm.assignKeyword($tag)"-->
        <!-- ************************************************************ -->
        <!-- Patient/Client Document Actions                              -->
        <!-- ************************************************************ -->

        <!-- patient docs -->
        <div class="row" ng-show="vm.file.doccat === 'patient'" data-hook="patientactions">
          <div class="col-xs-12 col-md-6">

            <div ng-hide="vm.file.clientid || vm.file.patientid">
              <label for="clientsearch">{{vm.kunde}}</label>
              <clientsearch parentsave="vm.saveClient(client, mode)" mode="{{vm.clientmode}}"
                            data-hook="assign-patient-name"
                            id="clientsearch"></clientsearch>
            </div>
            <div ng-show="vm.file.patientid">
              <label for="patient">Patient</label>

              <div class="input-group">
                <input type="text" class="form-control"
                       id="patient"
                       readonly
                       ng-model="vm.file.patientfname">
                <span class="input-group-btn">
                                <button class="btn btn-danger"
                                        ng-click="vm.clearPatient()"><i class="fa fa-remove"></i>
                                </button>
                            </span>
              </div>
            </div>
            <div ng-show="vm.file.clientid">
              <label for="client">Kunde</label>

              <div class="input-group">
                <input type="text" class="form-control"
                       id="client"
                       readonly
                       ng-model="vm.file.clientfname">
                <span class="input-group-btn">
                                <button class="btn btn-danger"
                                        ng-click="vm.clearClient()"><i class="fa fa-remove"></i>
                                </button>
                            </span>
              </div>
            </div>
          </div>
          <!-- PatientDokument type -->
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label for="patdoctype">{{vm.kunden}}-Dokumenttyp</label>
              <select id="patdoctype" data-hook="patient_doctype" ng-model="vm.file.type" class="form-control"
                      ng-change="vm.save()">
                <option ng-repeat="v in vm.dmspatientcat" value="{{v}}">{{v}}</option>
              </select>
            </div>
          </div>

          <div class="form-group col-xs-12" ng-show="vm.file.patientid">
            <label for="client">Diagnosen</label>
            <diagnosesedit diagnoses="vm.client.diagnoses" parentsave="vm.diagClientSave()"></diagnosesedit>
          </div>

          <!-- Logging -->
          <div class="form-group col-xs-12 col-md-6">
            <button type="button" ng-click="vm.addLog()"
                    uib-tooltip="Logeintrag für Patienten erstellen"
                    class="btn btn-success form-control"><i class="fa fa-plus"></i> {{vm.kunden}}-Logeintrag
            </button>
          </div>
          <!-- PatTodo -->
          <div class="form-group col-xs-12 col-md-6">
            <button type="button" ng-click="vm.addReminder()" uib-tooltip="Erinnerung für {{vm.kunden}} erstellen"
                    class="btn btn-success form-control"><i class="fa fa-plus"></i> {{vm.kunden}}-Erinnerung/Todo
            </button>
          </div>


          <!-- Befunde nachtragen -->
          <div class="col-xs-12" ng-show="vm.file.patientid">
            <h4>Untersuchungsergebnisse nachtragen</h4>
            <addexamdiagnoses patientid="vm.file.patientid"></addexamdiagnoses>
          </div>


        </div>

        <!-- ************************************************************ -->
        <!-- Generic Document Actions                                     -->
        <!-- ************************************************************ -->

        <div class="row" ng-show="vm.file.doccat === 'generic'" data-hook="genericactions">
          <div class="col-xs-12">
            <div class="form-group">
              <label for="gendoctype">Allgemeiner Dokumenttyp</label>
              <select id="gendoctype" ng-model="vm.file.type" class="form-control" ng-change="vm.save()">
                <option ng-repeat="v in vm.dmsgencat" value="{{v}}">{{v}}</option>
              </select>
            </div>
          </div>
        </div>

      </form>

    </div>
  </div>
</div>


<div class="row spacer-top">


</div>


<!-- tag template -->
<script type="text/ng-template" id="filetag-template">
  <div class="tag-template" style="z-index: 10000">
    <div class="right-panel">
      <span>{{$getDisplayText()}}</span>
      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>
    </div>
  </div>
</script>

<!-- tag autocomplete template -->
<script type="text/ng-template" id="filetagautocomplete-template">
  <div class="filetagautocomplete-template" style="z-index: 10000">
    <div>
      <span ng-bind-html="$highlight($getDisplayText())">{{text}}</span>
    </div>
  </div>
</script>